// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"476":"veranstaltungen","594":"about","596":"gruppen","665":"kontakt"}[chunkId] + "." + {"476":"284dd1cb","594":"769dfda8","596":"e9573a57","665":"0bc9b2e7"}[chunkId] + ".js";
};